<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend
        :loading="programLoading"
        :breadcrumbs="[
        { link: '/programas', text: 'Todos los programas' },
        { text: program.degree + ' en ' + program.name },
        ]"/>
    </section>
    <div class="row row-center" v-if="programLoading">
      <spin-loader :size="'100px'" />
    </div>
    <div v-else>
      <div v-if="programLoadError" class="row row-center">
        <div class="row">
          <img
            src="/assets/broken-page-primary.svg"
            class="lcu-program-brokenImg"
            alt="Program not loaded" />
        </div>
        <p class="lcu-programLoad-error">
          {{ programLoadError }}
        </p>
        <button-cta
          :text="TRY_AGAIN"
          :loading="programLoading"
          border
          @on-click="getProgram" />
      </div>
      <div v-else>
        <section class="section">
          <div class="lcu-programInfo-grid">
            <div>
              <header class="lcu-section-header">{{ program.degree }} en {{ program.name }}</header>
              <p>{{ program.description }}</p>
              <button-cta
                v-if="!(user.programs && user.programs[program?.slug])"
                :text="'REGISTRARSE AHORA'"
                :classes="['lcu-arrow-btn']"
                :type="'secondary'"
                @on-click="$router.push({ path: '/programas/registrarse/' + program.slug })" />
              <div v-else class="lcu-program-registered">
                Ya estás registrado en este programa.
                <router-link
                  class="lcu-registered-link"
                  :to="'/programas/registrada/' + program.slug">
                  Ve al programa
                </router-link>
              </div>
            </div>
            <img
              class="lcu-programInfo-logo"
              :src="program.image || DEFAULT_PROGRAM_IMAGE"
              alt="Program logo" />
          </div>
        </section>
        <section class="section">
        <hr class="line-break"/>
        </section>
        <section class="section">
          <header class="lcu-section-header">Resumen del plan de estudios</header>
            <ol class="lcu-curriculum-list">
              <li
                class="lcu-curriculum-item"
                :key="section.id"
                v-for="section in (program.sections || [])">
                <span class="lcu-curriculum-title">
                  {{ section.title }}
                </span>
                <span
                  class="lcu-curriculum-bullet"
                  :key="module.id"
                  v-for="module in (section.modules || [])">
                  {{ module.title }}
                </span>
              </li>
            </ol>
        </section>
      </div>
     </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import Announement from 'ç/announcement/Announcement.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import Programs from '@/mixins/Programs.vue';
import { DEFAULT_PROGRAM_IMAGE, TRY_AGAIN } from '@/globals/constants';

export default {
  name: 'view-program',
  mixins: [Programs],
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    PageLegend,
    ButtonCta,
    SpinLoader,
    'annoucement-banner': Announement,
  },
  data() {
    return {
      DEFAULT_PROGRAM_IMAGE,
      TRY_AGAIN,
    };
  },
  created() {
    this.getProgram();
  },
};
</script>

<style scoped lang="scss">
.lcu-programInfo-grid {
  display: grid;
  grid-gap: 50px;
  grid-template-columns: 1fr max-content;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 25px;
  }
}

.lcu-programInfo-logo {
  border: 1px solid $page-border;
  border-radius: 5px;
  width: 300px;
}

.lcu-arrow-btn {
  &:after {
    display: inline-block;
    font-family: 'lcu';
    content: '\e80a';
    margin-left: 10px;
  }
}

.lcu-curriculum-list {
  margin: 0;
  padding: 0 17px;
}

.lcu-curriculum-title {
  display: inline-block;
  text-decoration: underline;
  margin-bottom: 10px;
}

.lcu-curriculum-bullet {
  display: block;
  margin-bottom: 5px;

  &:before {
    content: '\2022';
    margin-left: 0;
  }
}

.lcu-curriculum-item {
  margin-bottom: 20px;
}

.lcu-programLoad-error {
  text-align: center;
  font-size: 18px;
}

.lcu-program-brokenImg {
  width: 165px;
}

.lcu-program-registered {
  display: inline-block;
  background-color: #dfeaf6;
  // color: $white;
  padding: 10px;
  border-radius: 5px;
}

.lcu-registered-link {
  color: inherit;

  &:after {
    font-family: 'lcu';
    content: '\e80a';
  }
}
</style>
